<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaArquivos"
    :search="search"
    :no-data-text="'Este projeto não possui arquivos.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.nome="props">
        <a :href="api_url + 'projetos/' + idProjeto + '/arquivos/' + props.item.idArquivo">
          <v-icon>fa fa-fw fa-download</v-icon>{{ props.item.nome.trim() }}
        </a>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaArquivos.length }} arquivos
      </template>
    </v-data-table>
    <br><br>
    <v-divider></v-divider>
    <v-card-actions v-if="projeto.funcao != null && projeto.funcao.item === 1">
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="toUploadArquivo" >Adicionar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto'],
  data: () => ({
    api_url: process.env.API_BASE_URL,
    listaArquivos: [],
    dates: dates,
    search: null,
    sortBy: 'dtInclusao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome', align: 'center', value: 'nome' },
      { text: 'Tipo', align: 'center', value: 'tipoArquivo.descricao' },
      { text: 'Acesso', align: 'center', value: 'nivelAcesso' },
      { text: 'Data de inclusão', align: 'center', value: 'dtInclusao' },
      { text: 'Observação', align: 'center', value: 'observacao' }
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toUploadArquivo: function () {
      this.$router.push({ name: 'UploadArquivo', params: {idProjeto: this.idProjeto} })
    },
    toAvancar: function () {
      this.$router.push({ name: 'RelatoriosProjeto', params: {idProjeto: this.idProjeto} })
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' })
    projetos.getArquivosDoProjeto(this.idProjeto)
    .then(response => {
      this.listaArquivos = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-editar-arquivos.vue?d4b19080